"use client";
import { getProductNavigationUrl, getProductFeaturesData } from "../../productService/lib.js";
import { isFeatureEnabledForApplication } from "../../../utils/contentstack/lib.js";
import { getInWareHouseChannelBadgeData, getCompareProductButtonData, getReviewRatingData, getReplacementItemNumber, getProductDeliveryBadgeData, getProductActions, getPriceData, getPillBadges, itemIsMemberOnlyPriceInCartOnly, getDiscountsData, getDeliveryChannelBadgeData, getColorSwatchesData, getInWarehouseAvailabilityText, getAddToListButtonData } from "./lib.js";
import { normalizePharmacyData } from "./normalizePharmacyData.js";
import { normalizeTravelData } from "./normalizeTravelData.js";
const normalizeLwData = (lwData, productConfig, hasUserSignedId, cookieContext, keyword, showMultiVariantsAvailability) => {
  const {
    pillBadgeConfig,
    imageConfig,
    featureToggleConfig,
    enabledWarehousesListConfig,
    translationsConfig
  } = productConfig || {};
  const normalizedData = lwData == null ? void 0 : lwData.map((item) => {
    var _a, _b, _c, _d, _e;
    if ((_a = item == null ? void 0 : item.content_type) == null ? void 0 : _a.includes("travelDestination")) {
      return normalizeTravelData(item);
    }
    if ((_b = item == null ? void 0 : item.content_type) == null ? void 0 : _b.includes("pharmacy")) {
      return normalizePharmacyData(
        item,
        translationsConfig,
        imageConfig == null ? void 0 : imageConfig.domainUrl
      );
    }
    const {
      item_fsa_eligible,
      hasLinkFee,
      item_pill_attributes,
      group_id,
      item_product_marketing_features,
      item_collateral_primaryimage,
      item_product_name,
      item_product_marketing_statement,
      item_number,
      item_chdi_eligible,
      item_product_status_published,
      Brand_attr,
      item_location_bopim,
      Bundle_attr,
      item_product_price_in_cart_only,
      item_location_pricing_discountAmount_f,
      item_location_pricing_salePrice,
      item_location_pricing_listPrice,
      Taxable_Food_others,
      linkfee_includeInPrice,
      linkfee_excludeFromPrice
    } = item || {};
    const inWarehouseChannelBadgeData = getInWareHouseChannelBadgeData(
      item,
      enabledWarehousesListConfig,
      featureToggleConfig,
      cookieContext,
      showMultiVariantsAvailability
    );
    return {
      addToListButtonData: getAddToListButtonData(item, cookieContext),
      availabilityInfoData: {
        bopimStatus: item_location_bopim,
        inWarehouseAvailabilityText: getInWarehouseAvailabilityText(item),
        inWarehouseChannelBadgeData
      },
      colorSwatchesData: getColorSwatchesData(
        item,
        imageConfig,
        featureToggleConfig
      ),
      deliveryChannelData: getDeliveryChannelBadgeData(
        item,
        cookieContext,
        featureToggleConfig
      ),
      discountsData: getDiscountsData(
        item_location_pricing_discountAmount_f
      ),
      isChdiEligible: Boolean(item_chdi_eligible),
      isEcoFeeEligible: Boolean(hasLinkFee),
      isFsaEligible: Boolean(item_fsa_eligible),
      isMemberOnlyItem: itemIsMemberOnlyPriceInCartOnly(item),
      isPublished: Boolean(item_product_status_published),
      pillBadges: getPillBadges(
        item_pill_attributes,
        pillBadgeConfig,
        imageConfig == null ? void 0 : imageConfig.domainUrl,
        keyword
      ),
      priceListData: getPriceData(item, cookieContext, {
        translationsConfig,
        inWarehouseChannelBadgeData,
        featureToggleConfig
      }),
      productActions: getProductActions(
        item,
        featureToggleConfig,
        translationsConfig,
        hasUserSignedId,
        cookieContext
      ),
      productDeliveryBadgeData: getProductDeliveryBadgeData(
        item,
        translationsConfig,
        imageConfig == null ? void 0 : imageConfig.domainUrl
      ),
      productInfoData: {
        itemNumber: item_number,
        partNumber: group_id,
        productBrand: (Brand_attr == null ? void 0 : Brand_attr[0]) || "",
        productFeaturesData: getProductFeaturesData(
          item_product_marketing_features == null ? void 0 : item_product_marketing_features[0]
        ),
        productImageUrl: item_collateral_primaryimage,
        productLinkUrl: getProductNavigationUrl(
          item_product_name,
          group_id,
          imageConfig == null ? void 0 : imageConfig.domainUrl,
          void 0,
          void 0,
          (_c = featureToggleConfig == null ? void 0 : featureToggleConfig.enableBModPDPNavigationUrl) == null ? void 0 : _c.isEnabled
        ),
        productName: item_product_name,
        replacementItemNumber: getReplacementItemNumber(item)
      },
      savingsData: {
        priceInCartOnly: item_product_price_in_cart_only !== "2",
        bundle: !!Bundle_attr,
        salePrice: item_location_pricing_salePrice,
        listPrice: item_location_pricing_listPrice,
        freightSavingsEnabled: isFeatureEnabledForApplication(
          (_d = featureToggleConfig.freightSavings) == null ? void 0 : _d.featureOn,
          (_e = featureToggleConfig.freightSavings) == null ? void 0 : _e.enabledApplications
        )
      },
      promoItem: {
        promoText: item_product_marketing_statement,
        promoTextColor: ""
      },
      reviewRatingData: getReviewRatingData(
        item,
        translationsConfig
      ),
      showCompareProductButton: getCompareProductButtonData(item),
      taxableFoodItem: Taxable_Food_others,
      linkFeePrices: [
        {
          fees: [
            {
              feeCategory: "EcoFee",
              excludeFromPrice: linkfee_excludeFromPrice == null ? void 0 : linkfee_excludeFromPrice.toString(),
              includeInPrice: linkfee_includeInPrice == null ? void 0 : linkfee_includeInPrice.toString()
            }
          ]
        }
      ]
    };
  });
  return normalizedData;
};
export {
  normalizeLwData
};
